/**
 * Инициалы пользователя для аватарок-фоллбеков (когда нет фото) — единая
 * логика всех аватарок платформы: «Иванов Роман» → «ИР», одно слово — первые
 * две буквы («Роман» → «РО»).
 *
 * Лежит в ядре client (не в identity): аватарки рисуют и платформенные
 * компоненты (UserButton), которым импорт из identity закрыт направлением
 * зависимостей.
 */
export function getUserInitials(name: string | null | undefined): string {
  const trimmed = (name ?? '').trim();
  if (!trimmed) return '';
  const parts = trimmed.split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return trimmed.slice(0, 2).toUpperCase();
}
